import React, { useEffect, useState, useCallback, useMemo } from "react";
import ListMenu from "./ListMenu/ListMenu";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Filter from "./Filter/Filter";
import Loading from "../../../../Utils/Loading/Loading";
import NotFound from "../../../../Utils/NotFound/NotFound";
import DepositCard from "./DepositCard";

const backend = await new Backend().init();

export default function Deposit({ master_id, userType, start, end }) {
  const windowSize = useSize();
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);

  const [totalDeposit, setTotalDeposit] = useState(0);
  const [bankWiseDepositList, setBankWiseDepositList] = useState([]);

  // 🔹 Memoized base object
  const base = useMemo(
    () => ({
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      start: start,
      end: end,
    }),
    [start, end],
  );

  // 🔹 Load Deposit Transactions Only
  const loadTransactions = useCallback(async () => {
    setLoading(true);

    const data =
      userType === 5
        ? { ...base, broker_id: localStorage.getItem("id") }
        : userType === 3
          ? { ...base, master_id: localStorage.getItem("id") }
          : userType === 2
            ? master_id
              ? { ...base, master_id }
              : { ...base, super_id: localStorage.getItem("id") }
            : master_id
              ? { ...base, master_id }
              : { ...base, admin_id: localStorage.getItem("id") };

    try {
      const res = await backend.transaction(data);

      if (res.error === "False") {
        const allTransactions = res.transactions || [];
        // 🔥 IMPORTANT: Only Deposit Entries
        const depositTransactions = allTransactions.filter(
          (tx) => tx.type === "Deposit", // optional safety condition
        );

        setTransactions(depositTransactions);
        setFilteredTransactions(depositTransactions);
        setTotalDeposit(res.totalDeposit);
        setBankWiseDepositList(res.bankWiseDepositList);
      } else if (res.logout === 1) {
        window.LogOut?.();
      } else {
        toast.error(res.message || "Failed to load transactions");
      }
    } catch (error) {
      console.error("Error loading transactions:", error);
      toast.error("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, [base, master_id, userType]);

  // 🔁 Initial load
  useEffect(() => {
    loadTransactions();
    window.loadTransactions = loadTransactions;
  }, [loadTransactions]);

  // 🔍 Search handler (search inside deposits only)
  const search = useCallback(
    (value) => {
      if (!value || value.trim().length < 2) {
        setFilteredTransactions(transactions);
        return;
      }

      const v = value.toLowerCase();

      const filtered = transactions.filter(
        (u) => u.account_number?.toLowerCase().includes(v),
        // u.amount?.toString().includes(v) ||
        // u.username?.toLowerCase().includes(v),
      );

      setFilteredTransactions(filtered);
    },
    [transactions],
  );

  // 🖥️ UI
  return (
    <div style={{ height: windowSize[1] - 160, width: windowSize[0] }}>
      <Filter
        records={filteredTransactions.length}
        search={search}
        totalDeposit={totalDeposit}
        bankWiseDepositList={bankWiseDepositList}
      />

      <ListMenu userType={userType} />

      <div
        style={{
          width: windowSize[0],
          height: windowSize[1] - 220,
          overflowY: "auto",
        }}
      >
        {loading ? (
          <div className="loadingContainer">
            <Loading height={windowSize[1] - 220} />
          </div>
        ) : filteredTransactions.length > 0 ? (
          filteredTransactions.map((item, index) => (
            <DepositCard
              key={item.id || index}
              userType={userType}
              item={item}
              index={index}
              reload={loadTransactions}
            />
          ))
        ) : (
          <NotFound
            height={windowSize[1] - 220}
            title="Nothing here"
            subtext="No Deposit Transactions Found."
          />
        )}
      </div>
    </div>
  );
}
